import EventEmitter from '../../services/eventEmitter';
import template from './timeframe-date.jade';

export class TimeframeDateController {
  /* @ngInject */
  constructor() {
    this.events = this.events || new EventEmitter();
  }

  onChange() {
    if (_.isDate(this.ngModel)) {
      this.events.emit('goto', this.ngModel);
    }
  }
}

export function TimeframeDateComponent() {
  return {
    template,
    controller: TimeframeDateController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      label: '@',
      ngModel: '=',
      events: '=?',
      selecting: '='
    },
    bindToController: true,
    link: function (scope, element, attrs) {
      scope.vm.name = _.last(attrs.ngModel.split('.'));

      element.find('.c-timeframe-date__label').bind('click', (event) => {
        scope.$apply(() => {
          scope.vm.editing = true;
          scope.vm.selecting = scope.vm.name;
        });
      });

      element.parents('timeframe').bind('click', (event) => {
        if (!element[0].contains(event.target)) {
          scope.$apply(() => scope.vm.editing = false);
        }
      });
    }
  };
};

export default angular.module('app.datetime.timeframe-date', [])
  .directive('timeframeDate', TimeframeDateComponent)



/** WEBPACK FOOTER **
 ** ./src/common/datetime/timeframe-date.js
 **/